export default __webpack_public_path__ + "images/icon-money.d9a8ac9.svg";